<template>
  <b-row>
    <b-col cols="6">
      <b-card :header="$t('list_available_headers')">
        <b-list-group class="synaplus-cosmo-scroll-higher-720">
          <draggable
            v-model="my_lhs_tables"
            class="drag-area"
            group="tables"
            :disabled="disabled"
          >
            <b-list-group-item
              v-for="element of my_lhs_tables"
              :key="element.uid"
              class="hand-pointer"
            >
              <span class="fas fa-grip-vertical fa-fw" />
              {{ all_tables.tables[element.uid].name }}
            </b-list-group-item>
          </draggable>
        </b-list-group>
      </b-card>
    </b-col>
    <b-col>
      <b-card :header="rhs_title">
        <b-list-group class="synaplus-cosmo-scroll-higher-720">
          <!--           <draggable
            v-model="my_rhs_elements"
            class="drag-area"
            group="tables"
            handle=".table-handle"
            :disabled="disabled"
          > -->
          <draggable
            v-model="my_rhs_elements"
            class="drag-area"
            group="tables"
            handle=".table-handle"
            :revert-on-spill="true"
            :on-spill="spilled_rhs_element"
            :disabled="disabled"
          >
            <slot
              v-for="element in my_rhs_elements"
              name="rhs_table_component"
              :element="element"
              :element_name="all_tables.tables[element.uid].name"
              :disabled="disabled"
            />
          </draggable>
        </b-list-group>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import _ from 'lodash'

import { mapGetters } from 'vuex'
import draggable from 'vuedraggable'

// *****************************************************************************

export default {
  name: 'CommunicatingTablesLists',
  components: {
    draggable,
  },
  props: [
    'brick_id',
    'rhs_title',
    'all_tables',
    // The field in the brick structure holding a list of
    // parameterizable tables
    'rhs_elements',
    // Structure from object model which holds the appropriate parameterization
    // for the brick holding list
    'lhs_is_fixed',
    'element_constructor',
    'disabled',
  ],
  data() {
    return {
      my_lhs_tables: [],
      my_rhs_elements: [],
    }
  },
  computed: {},
  watch: {
    all_tables: {
      immediate: true,
      handler(nv) {
        this.compute_my_tables()
      },
    },
    rhs_elements: {
      immediate: true,
      deep: true,
      handler(nv, ov) {
        if (!_.isEqual(nv, ov)) {
          this.compute_my_tables()
        }
      },
    },
    my_rhs_elements: {
      immediate: true,
      deep: true,
      handler(nv) {
        if (!_.isEqual(this.rhs_elements, nv)) {
          this.emit_lists()
        }
      },
    },
  },
  methods: {
    compute_my_tables() {
      let rhs = _.cloneDeep(this.rhs_elements)
      let rhs_uids = _.map(rhs, x => x.uid)
      let all_uids = this.all_tables.lists
      let lhs = []
      for (const uid of all_uids) {
        if (!rhs_uids.includes(uid) || this.lhs_is_fixed) {
          // Prevent self referencing
          if (uid !== this.brick_id) {
            let element = new this.element_constructor()
            element.uid = uid
            lhs.push(element)
          }
        }
      }
      ;[this.my_lhs_tables, this.my_rhs_elements] = [lhs, rhs]
    },
    emit_lists() {
      this.$emit('input', this.my_rhs_elements)
    },
    spilled_rhs_element(event) {
      if (this.lhs_is_fixed) {
        this.my_rhs_elements.splice(event.oldIndex, 1)
      }
    },
  },
}
</script>
